enum StatusAnamneseEnum {
    'Pendente' = 1,
    'Preenchido' = 2,
};
  
  export default StatusAnamneseEnum;
  